import * as utils from "./utils";
import {read, view, columns, title} from './appointment';

export const list = utils.listFn('',
  function (payload, schema, columns) {
    payload.endpoint = payload.caregiver ? 'getMyAppointmentsAsCaregiver' : 'getMyAppointmentsAsClient';
    delete payload.member_id;
    delete payload.caregiver;
    return payload;
  }, function (payload, schema, columns) {
    return {
      headers: {actas: payload.member_id},
    };
  });
export {read, view, columns, title};



// WEBPACK FOOTER //
// ./src/schemas/appointment-as.js